// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__3uKVD","show":"Menu_show__3lo89","iconSection":"Menu_iconSection__1Mqfe"};